import { Typeform } from 'types/MarketplaceAdResponse';
import { getTypeFormValues } from 'utils/getTypeformData';
import { Exterior, Interior, SummerTires, WinterTires } from 'enums/Condition';
import { CarSide, Seat, SnowTyre, SummerTyre } from 'icons/symbol';

export const getConditionItemLimit = (category: Record<string, string>, text: string) => {
  let limit = 0;
  Object.values(category).forEach((item, index) => {
    if (text.includes(item)) {
      limit = index;
    }
  });
  return limit;
};

export const getCarConditionItem = (typeform: Typeform[]) => {
  const interiorValue = getTypeFormValues(typeform, 'interior_condition')[0];
  const exteriorValue = getTypeFormValues(typeform, 'exterior_condition')[0];
  const winterTiresValue = getTypeFormValues(typeform, 'winter_tires_condition')[0];
  const summerTiresValue = getTypeFormValues(typeform, 'summer_tires_condition')[0];

  return [
    interiorValue
      ? {
          limit: getConditionItemLimit(Interior, interiorValue),
          text: interiorValue,
          title: 'Interiör',
          titleIcon: Seat,
        }
      : null,
    exteriorValue
      ? {
          limit: getConditionItemLimit(Exterior, exteriorValue),
          text: exteriorValue,
          title: 'Exteriör',
          titleIcon: CarSide,
        }
      : null,
    winterTiresValue
      ? {
          limit: getConditionItemLimit(WinterTires, winterTiresValue),
          text: winterTiresValue,
          title: 'Vinterdäck',
          titleIcon: SnowTyre,
        }
      : null,
    summerTiresValue
      ? {
          limit: getConditionItemLimit(SummerTires, summerTiresValue),
          text: summerTiresValue,
          title: 'Sommardäck',
          titleIcon: SummerTyre,
        }
      : null,
  ].flatMap((item) => (item ? [item] : []));
};
